import { Children, cloneElement } from 'react';
import { debug } from 'zf-web-infra';
import { Button, Dropdown, Menu, Space } from 'antd';
import { Icons } from 'zf-web-components/icons';
import type { ReactElement, ReactNode } from 'react';
import type { OperatorMenuItemProps, OperatorMenuProps } from './types';

export function OperatorMenu(props: OperatorMenuProps): ReactElement | null {
  const { title, items = [], icon, children, loading } = props;

  if (items.length === 0 && children == null) {
    return null;
  }

  const dropdownRender = (menu: ReactNode): ReactNode => {
    let customMenu: ReactElement | null = null;
    const filteredChildren = children?.filter(item => item.key != null);
    if (filteredChildren != null) {
      customMenu = (
        <Menu>
          {
            Children.map(filteredChildren, child => (
              <Menu.Item key={child.key} {...child.props}>
                {child.props.label ?? child.props.children}
              </Menu.Item>
            ))
          }
        </Menu>
      );
    }

    return (
      <>
        {items.length > 0 ? cloneElement(menu as ReactElement) : null}
        {customMenu}
      </>
    );
  };

  return (
    <Dropdown placement='bottomRight' menu={{ items }} dropdownRender={dropdownRender}>
      <Button loading={loading}>
        {icon}
        <Space>
          {title}
          <Icons name='DownOutlined' />
        </Space>
      </Button>
    </Dropdown>
  );
}

function MenuItem(props: OperatorMenuItemProps): ReactElement | null {
  debug.common('MenuItem', props);
  return null;
}

OperatorMenu.Item = MenuItem;
